import { lrfdComboData, asdComboData, noComboData, serviceComboData } from "./load-combination-data"

export class LoadCombination {
    constructor(name = null, combinationData = null) {
        this.name = name
        this.prettyEquations = []
        this.equations = []
        this.prettyExclude = []

        if(combinationData) {
            this.prettyEquations = combinationData["prettyEquations"]
            this.equations = combinationData["equations"]
            for( var i = 0; i < this.prettyEquations.length; i++ )
                this.prettyExclude.push(false);
            for( var i = 0; i < this.equations.length; i++ )
                this.equations[i]["exclude"] = false;
        }
    }

    lambdaOrCdValue(loadIndex) {
        switch(this.name) {
            case 'LRFD': return this.prettyEquations[loadIndex]['lambda']
            case 'ASD' : return this.prettyEquations[loadIndex]['Cd']
            default: return 1.0
        }
    }
    
    togglePrettyExclude(index) {
        if( index >= this.prettyExclude.length || index < 0 ) return;
        let countTrue = this.prettyExclude.filter( x => { return x === true }).length
        if(countTrue === this.prettyExclude.length - 1) {
            alert("You must select at least one load case");
            return;
        }
        this.prettyExclude[index] = !this.prettyExclude[index];
        this.equations[index]["exclude"] = !this.equations[index]["exclude"];
    }
}

export const lrfdCombinations = new LoadCombination('LRFD', lrfdComboData)
export const asdCombinations = new LoadCombination('ASD', asdComboData)
export const noCombinations = new LoadCombination('No Combos', noComboData)
export const serviceCases = new LoadCombination('Service Combos', serviceComboData)